import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin, { Draggable } from '@fullcalendar/interaction';
import { useRef, useCallback, useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { colorchange } from '../../utilities/Convertions';

const Cutter3 = ({ machine = 'Cutter 3' }) => {
  const calendarRef = useRef(null);
  const listItemsRef = useRef([]);
  const [sortOption, setSortOption] = useState('default');
  const [mergedData, setMergedData] = useState([]);
  const [rawMergedData, setRawMergedData] = useState([]); // Store unfiltered mergedData
  const [scheduleEvents, setScheduleEvents] = useState([]);
  const [allScheduleEvents, setAllScheduleEvents] = useState([]);
  const [isScheduleEditModalOpen, setIsScheduleEditModalOpen] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [scheduleEditFormData, setScheduleEditFormData] = useState({
    job: '',
    component: '',
    date: '',
    time: '',
    hours: '1',
    machine: 'Cutter 3',
    fink: '',
    bink: '',
    cuts: '',
    customer: '',
    status: '',
    id: '',
    form: ''
  });

  // API configuration
  const api = 'https://highgroundapi.herokuapp.com';
  const config = {
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*'
    }
  };

  // Fetch active jobs for the side list
  const getactive = async () => {
    try {
      const activeResponse = await axios.post(
        'https://highgroundsoftware.com/dash/dashboard/php/getactivejobs.php',
        { job: '123456' },
        config
      );
      console.log('Active Jobs Response:', activeResponse.data);

      const jobIds = activeResponse.data.map(item => item.quote);

      const impoResponse = await axios.post(
        'https://highgroundsoftware.com/dash/dashboard/php/getcutterimpo.php',
        { jobs: jobIds },
        config
      );
      console.log('Cutter Impo Response:', impoResponse.data);

      let mergedData = impoResponse.data.map(impo => {
        const matchingActiveJob = activeResponse.data.find(active => active.quote === impo.quote);
        return {
          ...impo,
          customer: matchingActiveJob ? matchingActiveJob.customer : null,
          job: matchingActiveJob ? matchingActiveJob.job : null,
          status: matchingActiveJob ? matchingActiveJob.status || 'On Incoming' : 'On Incoming',
          form: impo.form || ''
        };
      });

      console.log('Merged Data (Initial):', mergedData);

      const jobsFromMerged = mergedData
        .filter(item => item.job !== null)
        .map(item => item.job);
      console.log('Jobs from Merged Data:', jobsFromMerged);

      const opsResponse = await axios.post(
        'https://highgroundsoftware.com/dash/dashboard/php/getoperations.php',
        { jobs: jobsFromMerged },
        config
      );
      console.log('Operations Response:', opsResponse.data);

      mergedData = mergedData.map(impo => {
        const matchingOperation = opsResponse.data.find(op => op.job === impo.job);
        return {
          ...impo,
          currentstatus: matchingOperation ? matchingOperation.name : 'On Incoming',
          status: matchingOperation ? matchingOperation.name : 'On Incoming',
          presstime1: impo.presstime1 || '1',
          cuts: impo.cuts || '',
          dueDate: impo.dueDate || '',
          fink: impo.fink || '',
          bink: impo.bink || '',
          itemid: impo._id || `${impo.job}-${impo.component || ''}`,
          form: impo.form || ''
        };
      });

      console.log('All Schedule Events before filtering:', allScheduleEvents.map(evt => ({
        job: evt.extendedProps.job,
        component: evt.extendedProps.component,
        itemid: evt.extendedProps.itemid,
        form: evt.extendedProps.form
      })));

      // Store unfiltered data
      setRawMergedData(mergedData);

      // Filter out jobs whose itemid matches extendedProps.itemid in allScheduleEvents
      const filteredMergedData = mergedData.filter(item => {
        const itemId = String(item.itemid || '').trim();
        const isScheduled = allScheduleEvents.some(evt => {
          const evtItemId = String(evt.extendedProps.itemid || '').trim();
          return evtItemId === itemId;
        });
        if (isScheduled) {
          console.log(`Filtering out job with itemid: ${itemId}`);
        }
        return !isScheduled;
      });

      console.log('Filtered Merged Data:', filteredMergedData);
      setMergedData(filteredMergedData);
    } catch (error) {
      console.error('Error fetching data:', error);
      toast.error('Failed to fetch data from the server');
    }
  };

  // Fetch schedule data from API
  const getSchedule = async () => {
    try {
      const response540 = await axios.post(
        `${api}/sched/get`,
        { machine: 'Cutter 1' },
        config
      );
      console.log('Schedule Response Cutter 1:', response540.data);

      const response440 = await axios.post(
        `${api}/sched/get`,
        { machine: 'Cutter 2' },
        config
      );
      console.log('Schedule Response Cutter 2:', response440.data);

      const response340 = await axios.post(
        `${api}/sched/get`,
        { machine: 'Cutter 3' },
        config
      );
      console.log('Schedule Response Cutter 3:', response340.data);

      const jobs540 = response540.data
        .filter(item => item.job)
        .map(item => item.job);
      const jobs440 = response440.data
        .filter(item => item.job)
        .map(item => item.job);
      const jobs340 = response340.data
        .filter(item => item.job)
        .map(item => item.job);
      const allJobs = [...new Set([...jobs540, ...jobs440, ...jobs340])];

      let opsResponse = { data: [] };
      if (allJobs.length > 0) {
        opsResponse = await axios.post(
          'https://highgroundsoftware.com/dash/dashboard/php/getoperations.php',
          { jobs: allJobs },
          config
        );
        console.log('Operations Response for Schedules:', opsResponse.data);
      }

      const events540 = response540.data.map(item => {
        const matchingOperation = opsResponse.data.find(op => op.job === item.job);
        const currentstatus = item.status || 'On Incoming';
        return {
          itemid: item.id || `${item.job}-${item.component || ''}`,
          title: item.customer || 'N/A',
          start: item.start || null,
          end: item.end || null,
          extendedProps: {
            customer: item.customer || null,
            currentstatus,
            status: currentstatus,
            backgroundcolor: colorchange(currentstatus),
            hours: item.hours || '1',
            dueDate: item.dueDate || null,
            component: item.component || null,
            _id: item._id || null,
            fink: item.fink || '',
            bink: item.bink || '',
            cuts: item.cuts || '',
            job: item.job || '',
            itemid: item.id || `${item.job}-${item.component || ''}`,
            form: item.form || ''
          }
        };
      });

      const events440 = response440.data.map(item => {
        const matchingOperation = opsResponse.data.find(op => op.job === item.job);
        const currentstatus = item.status || 'On Incoming';
        return {
          itemid: item.id || `${item.job}-${item.component || ''}`,
          title: item.customer || 'N/A',
          start: item.start || null,
          end: item.end || null,
          extendedProps: {
            customer: item.customer || null,
            currentstatus,
            status: currentstatus,
            backgroundcolor: colorchange(currentstatus),
            hours: item.hours || '1',
            dueDate: item.dueDate || null,
            component: item.component || null,
            _id: item._id || null,
            fink: item.fink || '',
            bink: item.bink || '',
            cuts: item.cuts || '',
            job: item.job || '',
            itemid: item.id || `${item.job}-${item.component || ''}`,
            form: item.form || ''
          }
        };
      });

      const events340 = response340.data.map(item => {
        const matchingOperation = opsResponse.data.find(op => op.job === item.job);
        const currentstatus = item.status || 'On Incoming';
        return {
          itemid: item.id || `${item.job}-${item.component || ''}`,
          title: item.customer || 'N/A',
          start: item.start || null,
          end: item.end || null,
          extendedProps: {
            customer: item.customer || null,
            currentstatus,
            status: currentstatus,
            backgroundcolor: colorchange(currentstatus),
            hours: item.hours || '1',
            dueDate: item.dueDate || null,
            component: item.component || null,
            _id: item._id || null,
            fink: item.fink || '',
            bink: item.bink || '',
            cuts: item.cuts || '',
            job: item.job || '',
            itemid: item.id || `${item.job}-${item.component || ''}`,
            form: item.form || ''
          }
        };
      });

      console.log('Mapped Schedule Events Cutter 1:', events540);
      console.log('Mapped Schedule Events Cutter 2:', events440);
      console.log('Mapped Schedule Events Cutter 3:', events340);

      setScheduleEvents(machine === 'Cutter 1' ? events540 : machine === 'Cutter 2' ? events440 : events340);
      setAllScheduleEvents([...events540, ...events440, ...events340]);
    } catch (error) {
      console.error('Error fetching schedule:', error);
      setScheduleEvents([]);
      setAllScheduleEvents([]);
    }
  };

  // Save event to the backend
  const saveEvent = async (eventData, isUpdate = false) => {
    try {
      const endpoint = isUpdate && eventData.extendedProps?._id ? `${api}/sched/update` : `${api}/sched/add`;
      const formatDateWithOffset = (date) => {
        if (!date) return null;
        const offset = '-04:00';
        const pad = (num) => String(num).padStart(2, '0');
        const year = date.getFullYear();
        const month = pad(date.getMonth() + 1);
        const day = pad(date.getDate());
        const hours = pad(date.getHours());
        const minutes = pad(date.getMinutes());
        const seconds = pad(date.getSeconds());
        return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}${offset}`;
      };

      const payload = {
        dbid: eventData.extendedProps?._id || null,
        machine: eventData.extendedProps?.machine || machine || 'Cutter 3',
        job: eventData.extendedProps?.job || eventData.title,
        start: formatDateWithOffset(eventData.start),
        end: formatDateWithOffset(eventData.end),
        customer: eventData.extendedProps?.customer || null,
        currentstatus: eventData.extendedProps?.currentstatus || 'On Incoming',
        status: eventData.extendedProps?.status || eventData.extendedProps?.currentstatus || 'On Incoming',
        hours: eventData.extendedProps?.hours || '1',
        dueDate: eventData.extendedProps?.dueDate || null,
        component: eventData.extendedProps?.component || null,
        fink: eventData.extendedProps?.fink || '',
        bink: eventData.extendedProps?.bink || '',
        cuts: eventData.extendedProps?.cuts || '',
        itemid: eventData.extendedProps?.itemid || eventData.itemid,
        form: eventData.extendedProps?.form || ''
      };
      console.log(`Sending to ${endpoint}:`, payload);
      const response = await axios.post(endpoint, payload, config);
      console.log(`Event ${isUpdate ? 'updated' : 'saved'} response:`, response.data);

      if (isUpdate && (response.status === 404 || response.status === 400)) {
        console.warn(`Update failed: ${response.data.message}`);
        throw new Error(response.data.message);
      }
      return response.data._id || response.data.dbid;
    } catch (error) {
      console.error(`Error ${isUpdate ? 'updating' : 'saving'} event:`, error);
      throw error;
    }
  };

  // Delete event from the backend and restore to left-side list
  const handleScheduleRemove = async () => {
    if (!selectedEvent || !selectedEvent.extendedProps._id) {
      console.error('No valid event or _id for deletion');
      toast.error('Cannot delete event: Invalid event data');
      return;
    }

    const eventId = selectedEvent.extendedProps._id;
    const itemId = String(selectedEvent.extendedProps.itemid || '').trim();
    console.log('Removing event:', { itemid: itemId, _id: eventId, job: selectedEvent.extendedProps.job, component: selectedEvent.extendedProps.component, cuts: selectedEvent.extendedProps.cuts, form: selectedEvent.extendedProps.form });

    try {
      // Delete from backend
      await axios.post(`${api}/sched/remove`, { id: eventId }, config);
      console.log(`Event deleted from backend: ${eventId}`);

      // Remove from scheduleEvents and allScheduleEvents
      setScheduleEvents((prev) => prev.filter(evt => evt.extendedProps._id !== eventId));
      setAllScheduleEvents((prev) => prev.filter(evt => evt.extendedProps._id !== eventId));

      // Restore job to rawMergedData
      const restoredJob = {
        job: selectedEvent.extendedProps.job || '',
        component: selectedEvent.extendedProps.component || '',
        customer: selectedEvent.extendedProps.customer || null,
        currentstatus: selectedEvent.extendedProps.currentstatus || 'On Incoming',
        status: selectedEvent.extendedProps.status || 'On Incoming',
        presstime1: selectedEvent.extendedProps.hours || '1',
        cuts: selectedEvent.extendedProps.cuts || '',
        dueDate: selectedEvent.extendedProps.dueDate || '',
        fink: selectedEvent.extendedProps.fink || '',
        bink: selectedEvent.extendedProps.bink || '',
        itemid: itemId,
        quote: selectedEvent.extendedProps.job || '',
        form: selectedEvent.extendedProps.form || ''
      };
      console.log('Restoring job to rawMergedData:', restoredJob);

      setRawMergedData((prev) => {
        const exists = prev.some(item => String(item.itemid || '').trim() === itemId);
        if (exists) {
          console.log(`Job with itemid ${itemId} already in rawMergedData, skipping addition`);
          return prev;
        }
        return [...prev, restoredJob];
      });

      // Close modal
      setIsScheduleEditModalOpen(false);
      setSelectedEvent(null);

      // Refresh schedule and active jobs
      await getSchedule();
      await getactive();
      console.log('After delete - Merged Data:', mergedData);
      console.log('After delete - All Schedule Events:', allScheduleEvents.map(evt => ({
        job: evt.extendedProps.job,
        component: evt.extendedProps.component,
        itemid: evt.extendedProps.itemid,
        cuts: evt.extendedProps.cuts,
        form: evt.extendedProps.form
      })));
    } catch (error) {
      console.error('Error deleting event:', error);
      toast.error('Failed to delete event from schedule');
    }
  };

  // Duplicate the selected event
  const handleScheduleDuplicate = async () => {
    if (!selectedEvent) {
      console.error('No valid event for duplication');
      toast.error('Cannot duplicate event: No event selected');
      return;
    }

    const { job, component, hours, machine, fink, bink, cuts, customer, status, form } = scheduleEditFormData;
    if (!job || !hours || !machine) {
      console.error('Required fields missing for duplication');
      toast.error('Cannot duplicate event: Missing required fields (Job, Hours, Cutter)');
      return;
    }

    try {
      // Use modal inputs if modified, else fall back to selectedEvent
      const startDate = scheduleEditFormData.date && scheduleEditFormData.time
        ? new Date(`${scheduleEditFormData.date}T${scheduleEditFormData.time}:00`)
        : new Date(selectedEvent.end); // Start after original event's end
      const endDate = new Date(startDate);
      endDate.setHours(endDate.getHours() + parseFloat(hours || selectedEvent.extendedProps.hours || 1));

      const newEvent = {
        itemid: selectedEvent.extendedProps.itemid,
        title: customer || selectedEvent.extendedProps.customer || 'N/A',
        start: startDate,
        end: endDate,
        extendedProps: {
          customer: customer || selectedEvent.extendedProps.customer || null,
          currentstatus: status || selectedEvent.extendedProps.currentstatus || 'On Incoming',
          status: status || selectedEvent.extendedProps.status || 'On Incoming',
          backgroundcolor: colorchange(status || selectedEvent.extendedProps.status || 'On Incoming'),
          hours: hours || selectedEvent.extendedProps.hours || '1',
          dueDate: selectedEvent.extendedProps.dueDate || null,
          component: component || selectedEvent.extendedProps.component || null,
          _id: null, // New event, no _id yet
          fink: fink || selectedEvent.extendedProps.fink || '',
          bink: bink || selectedEvent.extendedProps.bink || '',
          cuts: cuts || selectedEvent.extendedProps.cuts || '',
          job: job || selectedEvent.extendedProps.job || '',
          itemid: selectedEvent.extendedProps.itemid,
          machine: machine || selectedEvent.extendedProps.machine || 'Cutter 3',
          form: form || selectedEvent.extendedProps.form || ''
        }
      };

      console.log('Duplicating event:', {
        itemid: newEvent.itemid,
        job: newEvent.extendedProps.job,
        component: newEvent.extendedProps.component,
        cuts: newEvent.extendedProps.cuts,
        form: newEvent.extendedProps.form,
        start: newEvent.start,
        end: newEvent.end
      });

      // Save the new event to the backend
      const newDbId = await saveEvent(newEvent, false);
      newEvent.extendedProps._id = newDbId;

      // Update local state
      setScheduleEvents((prev) => [...prev, newEvent]);
      setAllScheduleEvents((prev) => [...prev, newEvent]);

      // Close modal
      setIsScheduleEditModalOpen(false);
      setSelectedEvent(null);

      // Refresh schedule to sync with backend
      await getSchedule();
      console.log('After duplicate - All Schedule Events:', allScheduleEvents.map(evt => ({
        job: evt.extendedProps.job,
        component: evt.extendedProps.component,
        itemid: evt.extendedProps.itemid,
        cuts: evt.extendedProps.cuts,
        form: evt.extendedProps.form,
        start: evt.start,
        end: evt.end
      })));

      toast.success('Event duplicated successfully');
    } catch (error) {
      console.error('Error duplicating event:', error);
      toast.error('Failed to duplicate event');
    }
  };

  // Filter mergedData when allScheduleEvents changes
  useEffect(() => {
    if (rawMergedData.length > 0) {
      console.log('Filtering mergedData due to allScheduleEvents update:', allScheduleEvents.map(evt => ({
        job: evt.extendedProps.job,
        component: evt.extendedProps.component,
        itemid: evt.extendedProps.itemid,
        form: evt.extendedProps.form
      })));
      const filteredMergedData = rawMergedData.filter(item => {
        const itemId = String(item.itemid || '').trim();
        const isScheduled = allScheduleEvents.some(evt => {
          const evtItemId = String(evt.extendedProps.itemid || '').trim();
          return evtItemId === itemId;
        });
        if (isScheduled) {
          console.log(`Filtering out job with itemid: ${itemId}`);
        }
        return !isScheduled;
      });
      console.log('Updated Filtered Merged Data:', filteredMergedData);
      setMergedData(filteredMergedData);
    }
  }, [allScheduleEvents, rawMergedData]);

  // Initialize Draggable for list items
  useEffect(() => {
    const draggableInstances = [];
    listItemsRef.current.forEach((el, index) => {
      if (el && mergedData[index]) {
        const item = mergedData[index];
        const hours = parseFloat(item.presstime1) || 1;
        console.log('Setting Draggable for item:', {
          job: item.job,
          component: item.component,
          itemid: item.itemid,
          cuts: item.cuts,
          form: item.form
        });
        const draggable = new Draggable(el, {
          eventData: {
            title: item.customer || 'N/A',
            duration: `${Math.floor(hours)}:${(hours % 1 * 60).toFixed(0).padStart(2, '0')}:00`,
            extendedProps: {
              customer: item.customer || null,
              currentstatus: item.currentstatus || 'On Incoming',
              status: item.currentstatus || 'On Incoming',
              hours: item.presstime1 || '1',
              dueDate: item.dueDate || null,
              component: item.component || null,
              _id: item.itemid || null,
              fink: item.fink || '',
              bink: item.bink || '',
              cuts: item.cuts || '',
              job: item.job || '',
              itemid: item.itemid || `${item.job}-${item.component || ''}`,
              machine: machine || 'Cutter 3',
              form: item.form || ''
            }
          }
        });
        draggableInstances.push(draggable);
      }
    });

    return () => {
      draggableInstances.forEach(draggable => draggable.destroy());
    };
  }, [mergedData, machine]);

  // Handle sorting of the list
  useEffect(() => {
    let sorted = [...mergedData].sort((a, b) => {
      if (sortOption === 'dueDate') {
        const dateA = a.dueDate ? new Date(a.dueDate) : new Date(0);
        const dateB = b.dueDate ? new Date(b.dueDate) : new Date(0);
        return dateA - dateB;
      } else if (sortOption === 'job') {
        const jobA = a.job || '';
        const jobB = b.job || '';
        return jobA.localeCompare(jobB);
      } else if (sortOption === 'status') {
        const statusA = a.currentstatus || a.status || '';
        const statusB = b.currentstatus || b.status || '';
        return statusA.localeCompare(statusB);
      } else if (sortOption === 'customer') {
        const customerA = a.customer || '';
        const customerB = b.customer || '';
        return customerA.localeCompare(customerB);
      }
      return 0;
    });
    setMergedData(sorted);
  }, [sortOption]);

  // Fetch data on component mount and when machine changes
  useEffect(() => {
    const fetchData = async () => {
      try {
        await getSchedule();
        await getactive();
      } catch (error) {
        console.error('Error fetching initial data:', error);
        toast.error('Failed to fetch initial data');
      }
    };
    fetchData();
  }, [machine]);

  const handleEventReceive = useCallback(async (info) => {
    console.log('Event received:', {
      job: info.event.extendedProps.job,
      component: info.event.extendedProps.component,
      itemid: info.event.extendedProps.itemid,
      cuts: info.event.extendedProps.cuts,
      form: info.event.extendedProps.form
    });
    const droppedItemId = String(info.event.extendedProps.itemid || `${info.event.extendedProps.job}-${info.event.extendedProps.component || ''}`).trim();
    const newEvent = {
      itemid: droppedItemId,
      title: info.event.title,
      start: info.event.start,
      end: info.event.end,
      extendedProps: {
        customer: info.event.extendedProps.customer || 'N/A',
        status: info.event.extendedProps.status || 'On Incoming',
        job: info.event.extendedProps.job || info.event.title,
        hours: info.event.extendedProps.hours || '1',
        cuts: info.event.extendedProps.cuts || '',
        component: info.event.extendedProps.component || '',
        _id: info.event.extendedProps._id || null,
        fink: info.event.extendedProps.fink || '',
        bink: info.event.extendedProps.bink || '',
        backgroundcolor: colorchange(info.event.extendedProps.status || 'On Incoming'),
        machine: machine || 'Cutter 3',
        itemid: droppedItemId,
        form: info.event.extendedProps.form || ''
      }
    };

    try {
      // Save the new event to the backend
      const newDbId = await saveEvent(newEvent, false);
      newEvent.extendedProps._id = newDbId;

      // Update local state
      setScheduleEvents((prev) => [...prev, newEvent]);
      setAllScheduleEvents((prev) => [...prev, newEvent]);
      // Remove the dropped job from the side list
      setMergedData((prev) =>
        prev.filter(item => {
          const itemId = String(item.itemid || '').trim();
          return itemId !== droppedItemId;
        })
      );
      // Update rawMergedData to maintain consistency
      setRawMergedData((prev) =>
        prev.filter(item => {
          const itemId = String(item.itemid || '').trim();
          return itemId !== droppedItemId;
        })
      );
      // Refresh the schedule and active jobs to sync with backend
      await getSchedule();
      await getactive();
      console.log('After drop - Merged Data:', mergedData);
      console.log('After drop - All Schedule Events:', allScheduleEvents.map(evt => ({
        job: evt.extendedProps.job,
        component: evt.extendedProps.component,
        itemid: evt.extendedProps.itemid,
        cuts: evt.extendedProps.cuts,
        form: evt.extendedProps.form
      })));
    } catch (error) {
      console.error('Error saving dropped event:', error);
      toast.error('Failed to save event to schedule');
      // Remove the event from the calendar if API call fails
      info.event.remove();
    }
  }, [machine]);

  const handleEventDrop = useCallback(async (info) => {
    console.log('Event dropped (moved):', info.event.toPlainObject());
    const updatedEvent = {
      itemid: info.event.itemid,
      title: info.event.title,
      start: info.event.start,
      end: info.event.end,
      extendedProps: {
        ...info.event.extendedProps,
        backgroundcolor: colorchange(info.event.extendedProps.status || 'On Incoming')
      }
    };

    try {
      // Save the updated event to the backend
      await saveEvent(updatedEvent, true);

      // Update local state
      setScheduleEvents((prev) =>
        prev.map((evt) => (evt.itemid === info.event.itemid ? updatedEvent : evt))
      );
      setAllScheduleEvents((prev) =>
        prev.map((evt) => (evt.itemid === info.event.itemid ? updatedEvent : evt))
      );

      // Refresh schedule to sync with backend
      await getSchedule();
      console.log('After move - All Schedule Events:', allScheduleEvents.map(evt => ({
        job: evt.extendedProps.job,
        component: evt.extendedProps.component,
        itemid: evt.extendedProps.itemid,
        start: evt.start,
        end: evt.end,
        cuts: evt.extendedProps.cuts,
        form: evt.extendedProps.form
      })));
    } catch (error) {
      console.error('Error updating moved event:', error);
      toast.error('Failed to update event schedule');
      // Revert the event to its original position
      info.revert();
    }
  }, [machine]);

  const handleEventClick = useCallback((info) => {
    console.log('Event clicked:', info.event.toPlainObject());
    const job = info.event.extendedProps.job || info.event.title;
    const component = info.event.extendedProps.component || '';
    setScheduleEditFormData({
      job,
      component,
      date: info.event.start.toISOString().split('T')[0],
      time: info.event.start.toTimeString().slice(0, 5),
      hours: info.event.extendedProps.hours || '1',
      machine: machine || 'Cutter 3',
      fink: info.event.extendedProps.fink || '',
      bink: info.event.extendedProps.bink || '',
      cuts: info.event.extendedProps.cuts || '',
      customer: info.event.extendedProps.customer || '',
      status: info.event.extendedProps.status || info.event.extendedProps.currentstatus || 'On Incoming',
      id: info.event.extendedProps._id || '',
      form: info.event.extendedProps.form || ''
    });
    setSelectedEvent({
      itemid: info.event.itemid,
      title: info.event.title,
      start: info.event.start,
      end: info.event.end,
      extendedProps: info.event.extendedProps
    });
    setIsScheduleEditModalOpen(true);
  }, [machine]);

  const handleScheduleEditSubmit = async (e) => {
    e.preventDefault();
    const { job, component, date, time, hours, machine, fink, bink, cuts, customer, status, id, form } = scheduleEditFormData;

    if (!job || !date || !time || !hours || !machine) {
      alert('All required fields (Job, Date, Time, Hours, Cutter) must be filled');
      return;
    }
    if (isNaN(hours) || parseFloat(hours) <= 0) {
      alert('Hours must be a positive number');
      return;
    }

    try {
      const start = new Date(`${date}T${time}:00`);
      const end = new Date(start);
      end.setHours(end.getHours() + parseFloat(hours));

      // Log for debugging
      console.log('Submitting edit for itemid:', selectedEvent.itemid);
      console.log('Current scheduleEvents:', scheduleEvents.map(evt => ({
        itemid: evt.itemid,
        job: evt.extendedProps.job,
        component: evt.extendedProps.component,
        cuts: evt.extendedProps.cuts,
        form: evt.extendedProps.form
      })));

      // Find the original event, fall back to selectedEvent if not found
      const originalEvent = scheduleEvents.find(evt => evt.itemid === selectedEvent.itemid);
      if (!originalEvent) {
        console.warn('Original event not found in scheduleEvents, using selectedEvent');
      }

      const updatedEvent = {
        itemid: selectedEvent.itemid,
        title: customer || (originalEvent?.extendedProps?.customer ?? selectedEvent.extendedProps.customer) || 'N/A',
        start,
        end,
        extendedProps: {
          customer: customer || (originalEvent?.extendedProps?.customer ?? selectedEvent.extendedProps.customer) || null,
          currentstatus: (originalEvent?.extendedProps?.currentstatus ?? selectedEvent.extendedProps.currentstatus) || 'On Incoming',
          status: status || (originalEvent?.extendedProps?.currentstatus ?? selectedEvent.extendedProps.currentstatus) || 'On Incoming',
          backgroundcolor: colorchange(status || (originalEvent?.extendedProps?.currentstatus ?? selectedEvent.extendedProps.currentstatus) || 'On Incoming'),
          hours: hours.toString(),
          dueDate: (originalEvent?.extendedProps?.dueDate ?? selectedEvent.extendedProps.dueDate) || null,
          component: component || (originalEvent?.extendedProps?.component ?? selectedEvent.extendedProps.component) || null,
          _id: id || selectedEvent.extendedProps._id || null,
          fink: fink || (originalEvent?.extendedProps?.fink ?? selectedEvent.extendedProps.fink) || '',
          bink: bink || (originalEvent?.extendedProps?.bink ?? selectedEvent.extendedProps.bink) || '',
          cuts: cuts || (originalEvent?.extendedProps?.cuts ?? selectedEvent.extendedProps.cuts) || '',
          job,
          itemid: selectedEvent.itemid,
          machine: machine || (originalEvent?.extendedProps?.machine ?? selectedEvent.extendedProps.machine) || 'Cutter 3',
          form: form || (originalEvent?.extendedProps?.form ?? selectedEvent.extendedProps.form) || ''
        }
      };

      const newDbId = await saveEvent(updatedEvent, !!id);
      updatedEvent.extendedProps._id = newDbId;

      setScheduleEvents((prev) => prev.map((evt) => (evt.itemid === selectedEvent.itemid ? updatedEvent : evt)));
      setAllScheduleEvents((prev) => prev.map((evt) => (evt.itemid === selectedEvent.itemid ? updatedEvent : evt)));
      setIsScheduleEditModalOpen(false);

      await getSchedule();
      await getactive(); // Refresh left-side list after editing
      console.log('After edit - All Schedule Events:', allScheduleEvents.map(evt => ({
        job: evt.extendedProps.job,
        component: evt.extendedProps.component,
        itemid: evt.extendedProps.itemid,
        start: evt.start,
        end: evt.end,
        cuts: evt.extendedProps.cuts,
        form: evt.extendedProps.form
      })));
    } catch (error) {
      console.error('Error updating event from schedule edit modal:', error);
      alert('Failed to update event');
    }
  };

  const availableMachines = ['Cutter 1', 'Cutter 2', 'Cutter 3'];

  const renderEventContent = (eventInfo) => {
    const { event } = eventInfo;
    const { extendedProps } = event;
    const hours = extendedProps.hours && !isNaN(parseFloat(extendedProps.hours))
      ? Number(extendedProps.hours).toFixed(2)
      : ((event.end - event.start) / (1000 * 60 * 60)).toFixed(2) || '1.00';
    return (
      <div
        className="p-2 bg-gray-200 border-1 py-3"
        style={{
          background: colorchange(extendedProps.status || 'On Incoming'),
          fontSize: 'calc(1rem + .1vw)',
          width: '100%',
          height: '100%',
          overflow: 'hidden',
        }}
      >
        <strong style={{ fontSize: 'calc(.9rem + .1vw)', overflow: 'ellipsis' }}>
          {extendedProps.customer || 'N/A'}
        </strong>
        <br />
        Status: {extendedProps.status || 'On Incoming'}
        <br />
        Job: {extendedProps.job || 'N/A'} {extendedProps.component ? `- ${extendedProps.component}` : ''}
        <br />
        Hours: {hours}
        <br />
        Number of Cuts: {extendedProps.cuts || 'N/A'}
        <br />
        Form: {extendedProps.form || 'N/A'}
      </div>
    );
  };

  return (
    <div>
      <style>
        {`
          .draggable-item {
            font-size: 0.9rem;
            line-height: 1.2;
            overflow: hidden;
            cursor: move;
            user-select: none;
          }
          .fc-draggable.dragging, .draggable-item.dragging {
            font-size: 0.9rem !important;
            line-height: 1.2 !important;
            overflow: hidden !important;
            opacity: 0.8 !important;
          }
          .modal {
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background: white;
            padding: 20px;
            border-radius: 5px;
            box-shadow: 0 2px 10px rgba(0,0,0,0.2);
            z-index: 1000;
          }
          .modal-overlay {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0,0,0,0.5);
            z-index: 999;
          }
          .modal form {
            display: flex;
            flex-direction: column;
            gap: 10px;
          }
          .modal label {
            font-weight: bold;
          }
          .modal input, .modal select {
            padding: 5px;
            border: 1px solid #ccc;
            border-radius: 3px;
          }
          .modal button {
            margin-top: 10px;
            padding: 5px 10px;
            border: none;
            border-radius: 3px;
            cursor: pointer;
          }
          .modal button[type="submit"] {
            background: #28a745;
            color: white;
          }
          .modal button[type="button"] {
            background: #dc3545;
            color: white;
          }
          .modal button.remove {
            background: #ff4444;
            color: white;
          }
          .modal button.duplicate {
            background: #007bff;
            color: white;
          }
        `}
      </style>
      <div className='flex'>
        <div className='flex-[.3]' style={{ marginBottom: '10px' }}>
          <div className='flex'>
            <div className='flex-1' style={{ marginBottom: '10px' }}>
              <label htmlFor="sortOption">Sort by: </label>
              <select
                id="sortOption"
                value={sortOption}
                onChange={(e) => setSortOption(e.target.value)}
                style={{ padding: '0px', marginLeft: '5px' }}
              >
                <option value="default">Default</option>
                <option value="dueDate">Due Date</option>
                <option value="job">Job</option>
                <option value="status">Status</option>
                <option value="customer">Customer</option>
              </select>
            </div>
            <div className='flex-1 flex items-center justify-center'>
              {mergedData?.length} Jobs
            </div>
          </div>
          <div style={{ maxHeight: '115vh', overflowY: 'auto' }}>
            {mergedData?.length > 0 ? (
              mergedData.map((item, index) => (
                <div
                  key={item.itemid || `${item.job || 'unknown'}-${item.component || 'unknown'}-${index}`}
                  ref={(el) => (listItemsRef.current[index] = el)}
                  className="draggable-item p-2 m-1 bg-gray-200 cursor-move border-1 py-3"
                  style={{ borderBottom: '15px', padding: '5px', background: colorchange(item.currentstatus) }}
                >
                  <div style={{ fontSize: 'calc(1rem + .1vw)' }}>
                    <strong style={{ fontSize: 'calc(1.1rem + .1vw)' }}>{item.customer || 'N/A'}</strong><br />
                    Status: {item.currentstatus || 'On Incoming'}<br />
                    Job: {item.job || 'N/A'} - {item.component || 'N/A'}<br />
                    Hours: {Number(item.presstime1).toFixed(2) || 'N/A'}<br />
                    Number of Cuts: {item.cuts || 'N/A'}<br />
                    {item.fink ? `Front Ink: ${item.fink}` : null}
                    {item.bink ? ` / Back Ink: ${item.bink}` : null}
                    {item.form ? `Form: ${item.form}` : null}
                  </div>
                </div>
              ))
            ) : (
              <div>No jobs available</div>
            )}
          </div>
        </div>
        <div className='flex-1' style={{ padding: '0 10px', position: 'relative', color: 'black' }}>
          <h2>{machine || 'Cutter 3'} Schedule</h2>
          <FullCalendar
            ref={calendarRef}
            hiddenDays={[0]}
            plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
            initialView="timeGridWeek"
            events={scheduleEvents}
            editable={true}
            droppable={true}
            eventReceive={handleEventReceive}
            eventDrop={handleEventDrop}
            eventClick={handleEventClick}
            headerToolbar={{
              left: 'title',
              center: '',
              right: 'prev,next today dayGridMonth,timeGridWeek,timeGridDay'
            }}
            slotMinTime="05:00:00"
            slotMaxTime="17:30:00"
            allDaySlot={false}
            slotDuration="0:15:00"
            slotLabelInterval="0:30:00"
            height='115vh'
            eventConstraint={{ startTime: '00:00:00', endTime: '23:59:59' }}
            eventTextColor='black'
            eventContent={renderEventContent}
            eventDidMount={(info) => {
              const status = info.event.extendedProps.status || 'On Incoming';
              const color = colorchange(status);
              info.el.style.backgroundColor = color;
              info.el.style.borderColor = color;
              info.el.style.setProperty('textColor', 'black', 'important');
              info.el.title = `${info.event.title}\nCustomer: ${info.event.extendedProps.customer || 'N/A'}\nStatus: ${info.event.extendedProps.status || 'On Incoming'}\nJob: ${info.event.extendedProps.job || 'N/A'}\nNumber of Cuts: ${info.event.extendedProps.cuts || 'N/A'}\nForm: ${info.event.extendedProps.form || 'N/A'}`;
            }}
          />
        </div>
      </div>
      {isScheduleEditModalOpen && (
        <>
          <div className="modal-overlay" onClick={() => setIsScheduleEditModalOpen(false)}></div>
          <div className="modal">
            <h3>Edit Scheduled Event: {scheduleEditFormData.customer || 'N/A'}</h3>
            <form onSubmit={handleScheduleEditSubmit}>
              <label>
                Date:
                <input
                  type="date"
                  value={scheduleEditFormData.date}
                  onChange={(e) => setScheduleEditFormData({ ...scheduleEditFormData, date: e.target.value })}
                  required
                />
              </label>
              <label>
                Start Time:
                <input
                  type="time"
                  value={scheduleEditFormData.time}
                  onChange={(e) => setScheduleEditFormData({ ...scheduleEditFormData, time: e.target.value })}
                  step="1800"
                  required
                />
              </label>
              <label>
                Hours:
                <input
                  type="number"
                  value={scheduleEditFormData.hours}
                  onChange={(e) => setScheduleEditFormData({ ...scheduleEditFormData, hours: e.target.value })}
                  min="0.1"
                  step="0.01"
                  required
                />
              </label>
              <label>
                Cutter:
                <select
                  value={scheduleEditFormData.machine}
                  onChange={(e) => setScheduleEditFormData({ ...scheduleEditFormData, machine: e.target.value })}
                  required
                >
                  {availableMachines.map(m => (
                    <option key={m} value={m}>{m}</option>
                  ))}
                </select>
              </label>
              <label>
                Number of Cuts:
                <input
                  type="text"
                  value={scheduleEditFormData.cuts}
                  onChange={(e) => setScheduleEditFormData({ ...scheduleEditFormData, cuts: e.target.value })}
                />
              </label>
              <label>
                Customer:
                <input
                  type="text"
                  value={scheduleEditFormData.customer}
                  onChange={(e) => setScheduleEditFormData({ ...scheduleEditFormData, customer: e.target.value })}
                />
              </label>
              <label>
                Status:
                <input
                  type="text"
                  value={scheduleEditFormData.status}
                  onChange={(e) => setScheduleEditFormData({ ...scheduleEditFormData, status: e.target.value })}
                />
              </label>
              <label>
                Form:
                <input
                  type="text"
                  value={scheduleEditFormData.form}
                  onChange={(e) => setScheduleEditFormData({ ...scheduleEditFormData, form: e.target.value })}
                />
              </label>
              <button type="submit">Save</button>
              <button type="button" onClick={() => setIsScheduleEditModalOpen(false)}>Cancel</button>
              <button type="button" className="remove" onClick={handleScheduleRemove}>Remove</button>
              <button type="button" className="duplicate" onClick={handleScheduleDuplicate}>Duplicate</button>
            </form>
          </div>
        </>
      )}
    </div>
  );
};

export default Cutter3;